import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { apiGet } from "../../api/client";
import type { AdminReports, User } from "../../types";

export function AdminOverviewPage() {
  const { data: reports } = useQuery({
    queryKey: ["admin-reports"],
    queryFn: () => apiGet<AdminReports>("/api/admin/reports"),
  });
  const { data: users } = useQuery({
    queryKey: ["admin-users"],
    queryFn: () => apiGet<User[]>("/api/admin/users"),
  });

  const learners = users?.filter((u) => u.role === "learner").length ?? 0;
  const instructors = users?.filter((u) => u.role === "instructor").length ?? 0;
  const admins = users?.filter((u) => u.role === "admin").length ?? 0;

  return (
    <div className="admin-overview">
      <h1>Admin Console</h1>

      <div className="stats-grid">
        <div className="stat-card">
          <span className="stat-value">{learners}</span>
          <span className="stat-label">Learners</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">{instructors}</span>
          <span className="stat-label">Instructors</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">{admins}</span>
          <span className="stat-label">Admins</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">{reports?.platform.curricula ?? 0}</span>
          <span className="stat-label">Curricula</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">{reports?.platform.dialogs_completed ?? 0}</span>
          <span className="stat-label">Dialogs Completed</span>
        </div>
      </div>

      <div className="admin-nav-cards">
        <Link to="/admin/users" className="card admin-link-card">
          <h3>👥 User Management</h3>
          <p>Create, edit, enable/disable accounts and assign roles.</p>
        </Link>
        <Link to="/admin/curricula" className="card admin-link-card">
          <h3>📚 Curricula</h3>
          <p>Assign instructors to curricula.</p>
        </Link>
        <Link to="/admin/reports" className="card admin-link-card">
          <h3>📊 Reports</h3>
          <p>Platform-wide and per-instructor analytics.</p>
        </Link>
      </div>
    </div>
  );
}
